import i18n from "../i18n";

// Tarih/sayı biçimi seçili dile uyar; sayfalarda sabit 'tr-TR' yazmayın.
const LOCALES = { tr: "tr-TR", en: "en-GB" };
export const currentLocale = () => LOCALES[(i18n.language || "tr").slice(0, 2)] || LOCALES.tr;

export function formatDate(value, options = { dateStyle: "medium", timeStyle: "short" }) {
  if (!value) return "—";
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : new Intl.DateTimeFormat(currentLocale(), options).format(d);
}

export function formatNumber(value, options) {
  return typeof value === "number" && Number.isFinite(value) ? new Intl.NumberFormat(currentLocale(), options).format(value) : "—";
}
